import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
import IconBase, { IconProps } from '../IconBase';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const IconSuccess24 = (baseProps: IconProps, ref: Ref<SVGSVGElement>) => {
  return <IconBase {...baseProps}>
        {({
      title,
      titleId,
      ...props
    }: Partial<React.SVGProps<SVGSVGElement>> & SVGRProps) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" clipRule="evenodd" d="M12.0001 2.29994C6.64289 2.29994 2.30005 6.64278 2.30005 11.9999C2.30005 17.3571 6.64289 21.6999 12.0001 21.6999C17.3572 21.6999 21.7 17.3571 21.7 11.9999C21.7 6.64278 17.3572 2.29994 12.0001 2.29994ZM0.70005 11.9999C0.70005 5.75912 5.75923 0.699941 12.0001 0.699941C18.2409 0.699941 23.3 5.75912 23.3 11.9999C23.3 18.2408 18.2409 23.2999 12.0001 23.2999C5.75923 23.2999 0.70005 18.2408 0.70005 11.9999ZM10.9199 14.9507L15.4005 7.73781L16.7596 8.58208L11.6907 16.7421L11.1024 17.6892L10.3936 16.8285L6.8225 12.4921L8.0576 11.475L10.9199 14.9507Z" fill="currentColor" /></svg>}
      </IconBase>;
}; // This explicit type declaration prevents TypeScript from expanding IconProps into a huge Pick type
const ForwardRef: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>> = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return IconSuccess24(props, ref);
});
export default ForwardRef;